import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from '@pella/sash-framework';
import styles from './index.module.scss';

const CalendarRow = ({ children }) => (
	<Row>
		<Column
			xs='12'
			className={styles.rtaCalendar_Row_Wrapper}
		>
			{children}
		</Column>
	</Row>
);

CalendarRow.propTypes = {
	children: PropTypes.any,
};

export default CalendarRow;
